/**
 * Service for media queries
 * @link https://github.com/jacopotarantino/angular-match-media
 */
/* jshint ignore:start */
(function () {
    'use strict';

    /**
     * Screen size service
     */
    angular.module('itxApp.common').service('ItxScreenSizeSvc', ItxScreenSizeSvc);

    ItxScreenSizeSvc.$inject = ['$rootScope', 'logger'];

    function ItxScreenSizeSvc($rootScope, logger) {

        this.isDeviceMobile = function() {
            return (
                navigator.userAgent.match(/iPad/i) || 
                navigator.userAgent.match(/iPhone/i) || 
                navigator.userAgent.match(/Android/i) || 
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPod/i) || 
                navigator.userAgent.match(/BlackBerry/i) || 
                navigator.userAgent.match(/Windows Phone/i)
            )
        };
        
        var defaultRules = {
            xs: '(max-width: 767px)',
            sm: '(min-width: 768px) and (max-width: 991px)',   
            md: '(min-width: 992px) and (max-width: 1279px)',
            lg: '(min-width: 1280px)'
        };
 
        var extendedRules = {
            xs: '(max-width: 767px)',
            sm: '(min-width: 768px) and (max-width: 991px)',
            md1: '(min-width: 992px) and (max-width: 1024px)',
            md2: '(min-width: 1025px) and (max-width: 1279px)',
            lg: '(min-width: 1280px) and (max-width: 1600px)',
            lg2: '(min-width: 1601px)'          
           // xs2: '(max-width: 991px)',
        };

        this.isRetina = (
            window.devicePixelRatio > 1 ||
            (window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 1.5),(-moz-min-device-pixel-ratio: 1.5),(min-device-pixel-ratio: 1.5),(min-resolution: 192dpi),(min-resolution: 2dppx)').matches)
        );

        var that = this;

        // Executes Angular $apply in a safe way
        var safeApply = function (fn, scope) {
            scope = scope || $rootScope;
            var phase = scope.$root.$$phase;
            if (phase === '$apply' || phase === '$digest') {
                if (fn && (typeof (fn) === 'function')) {
                    fn();
                }
            } else {
                scope.$apply(fn);
            }
        };

        // Validates that we're getting a string or array.
        // When string: converts string(comma seperated) to an array.
        var assureList = function (list) {

            if (typeof list !== 'string' && Object.prototype.toString.call(list) !== '[object Array]') {
                throw new Error('screenSize requires array or comma-separated list');
            }

            return typeof list === 'string' ? list.split(/\s*,\s*/) : list;
        };

        var getCurrentMatch = function () {
            var rules = that.rules || defaultRules;

            for (var property in rules) {
                if (rules.hasOwnProperty(property)) {
                    if (window.matchMedia(rules[property]).matches) {
                        return property;
                    }
                }
            }
        };
        
        var getCurrentMatchExtended = function () {
            var rules = that.rules || extendedRules;

            for (var property in rules) {
                if (rules.hasOwnProperty(property)) {
                    if (window.matchMedia(rules[property]).matches) {
                        return property;
                    }
                }
            }
        };

        // Return the actual size (it's string name defined in the rules)
        this.get = getCurrentMatch;

        this.is = function (list) {
            list = assureList(list);
            return list.indexOf(getCurrentMatch()) !== -1;
        };
        
        this.isExtended = function (list) {
            list = assureList(list);
            return list.indexOf(getCurrentMatchExtended()) !== -1;
        };

        // Executes the callback function on window resize with the match truthiness as the first argument.
        // Returns the current match truthiness.
        // The 'scope' parameter is optional. If it's not passed in, '$rootScope' is used.
        this.on = function (list, callback, scope) {
            $(window).on('debouncedresize', listenerFunc);

            if (scope) {
                scope.$on('$destroy', function () {
                    $(window).off('debouncedresize', listenerFunc);
                });
            }

            return that.is(list);

            function listenerFunc() {
                safeApply(callback(that.is(list)), scope);
            }
        };

        // Executes the callback function ONLY when the match differs from previous match.
        // Returns the current match truthiness.
        // The 'scope' parameter is required for cleanup reasons (destroy event).
        this.onChange = function (scope, list, callback) {
            var currentMatch = getCurrentMatch();
            list = assureList(list);
            if (!scope) {
                throw 'scope has to be applied for cleanup reasons. (destroy)';
            }

            $(window).on('debouncedresize', listenerFunc);

            scope.$on('$destroy', function () {
                $(window).off('debouncedresize', listenerFunc);
            });

            return that.is(list);

            function listenerFunc() {
                var previousMatch = currentMatch;
                currentMatch = getCurrentMatch();

                var wasPreviousMatch = list.indexOf(previousMatch) !== -1;
                var doesCurrentMatch = list.indexOf(currentMatch) !== -1;
                if (wasPreviousMatch !== doesCurrentMatch) {
                    safeApply(callback(doesCurrentMatch), scope);
                }
            }
        };

        // Executes the callback only when inside of the particular screensize.
        // The 'scope' parameter is optional. If it's not passed in, '$rootScope' is used.
        this.when = function (list, callback, scope) {
            $(window).on('debouncedresize', function () {
                if (that.is(list) === true) {
                    safeApply(callback(that.is(list)), scope);
                }
            });

            return that.is(list);
        };
          // Executes the callback only when inside of the particular screensize.
        // The 'scope' parameter is optional. If it's not passed in, '$rootScope' is used.
        this.whenExtended= function (list, callback, scope) {
            $(window).on('debouncedresize', function () {
                if (that.is(list) === true) {
                    safeApply(callback(that.isExtended(list)), scope);
                }
            });

            return that.is(list);
        };

        this.isMobile = function () {
            if( this.isDeviceMobile() ){
                return true;
            } else {
                return !window.matchMedia('(min-width: 1280px)').matches;
            }
        };

        this.isDesktop = function () {
            return !this.isMobile();
        };
        
        // RELOAD FORCED
        var mobile = !window.matchMedia('(min-width: 1280px)').matches;
        function setDevice() {
            if( mobile && window.matchMedia('(min-width: 1280px)').matches || !mobile && !window.matchMedia('(min-width: 1280px)').matches ){
                document.location.reload();
            }
        }
        jQuery(window).on('resize', _.debounce(setDevice, 150));
        
    }

})();

/*
 * debouncedresize: special jQuery event that happens once after a window resize
 *
 * latest version and complete README available on Github:
 * https://github.com/louisremi/jquery-smartresize
 *
 * Copyright 2012 @louis_remi
 * Licensed under the MIT license.
 *
 * This saved you an hour of work?
 * Send me music http://www.amazon.co.uk/wishlist/HNTU0468LQON
 */
(function ($) {
    var $event = $.event,
        $special,
        resizeTimeout;

    $special = $event.special.debouncedresize = {
        setup: function () {
            $(this).on('resize', $special.handler);
        },
        teardown: function () {
            $(this).off('resize', $special.handler);
        },
        handler: function (event, execAsap) {
            // Save the context
            var context = this,
                args = arguments,
                dispatch = function () {
                    // set correct event type
                    event.type = 'debouncedresize';
                    $event.dispatch.apply(context, args);
                };

            if (resizeTimeout) {
                clearTimeout(resizeTimeout);
            }

            execAsap ?
                dispatch() :
                resizeTimeout = setTimeout(dispatch, $special.threshold);
        },
        threshold: 150
    };

})(jQuery);
/* jshint ignore:end */